<template>
    <div class="edit-profile">
        <div class="box">
            <Advertisement/>
        </div>
        <div class="box">
        <div class="edits">
            <SystemNotification v-if="message != null" :message="message"/>
            <div class="heading2-section">
                Log In
            </div>
        <form @submit.prevent="login">

        <div class="mb-3">
            <label class="form-label">Email Address</label>
            <input type="text" v-model="user.email" class="form-control">
        </div>
         <div class="mb-3">
            <label class="form-label">Password</label>
            <input type="password" v-model="user.password" class="form-control">
        </div>
         <div class="form-buttons mb-3">

                <button type="submit" class="btn btn-default primary-btn primary-btn-disabled" v-if="loading" disabled>Logging In...</button>
                <button type="submit" class="btn btn-default primary-btn" v-else>Login</button>
            </div>
          <!-- errors -->
        <div class="errors" v-if="hasErrors">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors -->     
        </form>
        <div class="bottom-links">
        <router-link class="bottom-link-mobile" style="text-decoration:none;color:var(--sidenav-link-active);font-weight: bold;" to="/signup">Sign Up</router-link>
        <router-link style="text-decoration:none;color:var(--sidenav-link-active);font-weight: bold;" to="/forgot-password">Forgot your password?</router-link>
        </div>
        <LoadingIndicator v-if="loading"/>
        </div>
        </div>
    </div>
    <ConfirmationMessageModal :title="modal.caption" :body="modal.message" button-label="Close" :close-modal="() => closeModal()"/>
</template>
<script>
import { loginAsync } from '@/services/authService';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import ConfirmationMessageModal from '@/components/modals/ConfirmationMessageModal.vue';
import Modal from 'bootstrap/js/dist/modal'
import Advertisement from '../shared/Advertisement.vue';
import SystemNotification from '@/components/Utility/SystemNotification.vue';

export default {
    components:{
        LoadingIndicator,
        ConfirmationMessageModal, Advertisement, SystemNotification
    },
    data(){
        return{
            url: process.env.VUE_APP_API_URL,
            user:{
                    email:"",
                    password:""
                },
            modal:{
                caption:"",
                message:""
            },
            confirmModal: null,
            errors:[],
            loading:false,
            hasErrors:false,
            message: this.$route.query.message
        }
    },
      mounted(){
        this.confirmModal = new Modal(document.getElementById('confirmMessageModal'))
        // this.$refs.loginContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.scrollTo({top: 0,behavior: 'smooth'});
    },
     methods:{
     async login(){
        try{
            this.resetOnNewSubmit();
            var data = await loginAsync(this.user);
            this.loading = false;
            if(data.success){
                //set in state management
                this.$store.dispatch('auth/setAuthenticatedUser', data);
                
                // Decide redirect based on role - ensure exactly one role
                const roles = data.user?.roles || [];
                
                if (roles.length === 1){
                    if (roles[0] === "JobSeeker") {
                        this.$router.push("/");
                    } else if (roles[0] === "Employer") {
                        this.$router.push("/enterprise/home");
                    }  else if(roles[0] === "Admin"){
                        this.$router.push("/admin/dashboard");
                    }        
                } else {
                    // more than one role or none
                    this.$router.push("/");
                }

            }else{
                if(data.notConfirmed){
                    sessionStorage.setItem('signup-email', this.user.email);
                    this.$router.push("/verification");
                    return;
                }
                if(data.errors){
                    data.errors.forEach((err) => {
                        this.errors.push(err);
                    });
                    this.hasErrors = true;
                    return;
                }
                throw new Error(data.message, {cause: data.caption})
            }
        
        }catch(e){
            this.loading = false;
            let message = e.message || "Something went wrong. Please try later";
            this.errors.push(message);
            this.hasErrors = true;
        }     
    },
    resetOnNewSubmit(){
            this.loading = true;
            this.hasErrors = false;
            this.errors = [];
    },
    closeModal(){
      this.confirmModal.hide();
    },
    showModal(){
        this.confirmModal.show();
    }
   }
}
</script>
<style scoped>

.primary-btn{
    width:100%;
}

.edit-profile{
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    margin-top:1.4rem;
}

.box:last-child{
    overflow-y: auto;
    max-height:80vh;
}

.edits{
    grid-column:2/3;
    padding:1rem 5rem;
}

    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}



input{
    border:0px!important;
}

.bottom-links{
    display: grid;
    grid-template-rows:auto auto;
}

.bottom-link-mobile{
    display: none;
}


@media (max-width:768px) {
    .edits{
    grid-column:1/4;
    margin:0rem 0.8rem;
    padding:0rem 0.1rem;
}

.box:first-child{
    display: none;
}

.edit-profile{ 
    margin:1rem 0rem;

    grid-template-columns: auto ;
}

.bottom-link-mobile{
    display: block;
}
}
</style>